<template>
    <v-container fluid>
        <div v-if="prj">
            <h1 class="text-center bot-blue">{{ prj.ProjectHost }}</h1>
            <bot-table v-if="keywordList.length" :dataSource="keywordList" :options="keyword.options">
            </bot-table>
            <v-alert v-else class="alert-message" type="warning">
                Dự án "{{ prj.ProjectTitle }}" chưa có từ khóa nào, hãy thêm từ
                khóa!
            </v-alert>
            <div class="text-center">
                <v-btn class="ma-2" color="primary" @click="() => updateKeyword(prj)">
                    Thêm từ khóa
                    <v-icon right> mdi-plus-circle </v-icon>
                </v-btn>
            </div>
        </div>
        <v-alert v-else class="alert-message" type="error">
            Xin lỗi chúng tôi không tìm thấy dự án này!
        </v-alert>
        <link-ranking-item v-model="selectedItem" />
    </v-container>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
import BotTable from "@/components/bot/table/bot.table.vue";
import LinkRankingItem from "./link.ranking.item.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            projects: {
                loadDetail: "views/projects/loadDetail",
            },
            link: {
                ranking: {
                    loadList: "views/link/ranking/loadList",
                },
            },
        },
    },
    sms: {
        success: {
            update: "Cập nhật từ khóa thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "link-ranking",

    components: {
        "bot-spinner": BotSpinner,
        "bot-table": BotTable,
        "link-ranking-item": LinkRankingItem,
    },

    // this is state
    data() {
        return {
            hlog: this.$options.filters.hlog,
            keyword: {
                options: {
                    headers: [
                        {
                            text: "STT",
                            value: "STT",
                        },
                        {
                            text: "Từ khóa",
                            value: "KeywordName",
                        },
                    ],
                },
            },
            selectedItem: {
                showDialog: false,
            },
        };
    },

    async asyncData({
        store,
        route: {
            params: { id },
        },
    }) {
        const dp = store.dispatch;
        let payload = { ProjectID: id };
        let requests = [
            dp(df.sp.projects.loadDetail, payload),
            dp(df.sp.link.ranking.loadList, payload),
        ];
        await Promise.all(requests);
    },

    computed: {
        prj() {
            let { id } = this.$route.params;
            let item = this.$store.state.views.projects.detail[id];
            return item;
        },
        keywordList() {
            let keywords = this.$store.state.views.link.ranking;
            let list = [];
            for (let [k, kw] of keywords.list.entries()) {
                let obj01 = { STT: k + 1 };
                let obj02 = kw;
                let obj = Object.assign(obj01, obj02);
                list.push(obj);
            };
            return list;
        },
    },

    methods: {
        updateKeyword(prj) {
            var main = this;
            let dialog = { showDialog: true, prj };
            main.selectedItem = dialog;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.alert-message {
    max-width: 600px;
    display: block;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// link.ranking.list.vue